import { render, staticRenderFns } from "./TypeWriter.vue?vue&type=template&id=74871208&scoped=true"
import script from "./TypeWriter.vue?vue&type=script&lang=js"
export * from "./TypeWriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74871208",
  null
  
)

export default component.exports